/**
 * Temporary spot for values for embeddable boards
 *
 * Copyright (c) 2022 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
const STAGING_DESTINATIONS = [{
  destination: 'Portland, OR',
  photoUrl: '/static/assets/img/backgrounds/destinations/portland.jpg',
  embedUrl: {
    browser: `${__MAIN_URL__}/embed/QiHliSb5CrVu4l3ED6ZzQ?view=grid&map=true`,
    mobile: `${__MAIN_URL__}/embed/QiHliSb5CrVu4l3ED6ZzQ?view=list&map=true`
  }
}, {
  destination: 'Las Vegas, NV',
  photoUrl: '/static/assets/img/backgrounds/destinations/las-vegas.jpg',
  labelColor: '#595CFF',
  embedUrl: {
    browser: `${__MAIN_URL__}/embed/QiHliSb5CrVu4l3ED6ZzQ?map=true`
  }
}, {
  destination: 'San Francisco, CA',
  photoUrl: '/static/assets/img/backgrounds/destinations/san-francisco.jpg',
  labelColor: '#00E3DE',
  textColor: '#1C1C1C',
  embedUrl: {
    browser: `${__MAIN_URL__}/embed/QiHliSb5CrVu4l3ED6ZzQ?view=list&map=true`
  }
}, {
  destination: 'New York, NY',
  photoUrl: '/static/assets/img/backgrounds/destinations/new-york.jpg',
  labelColor: '#FF4733',
  textColor: '#1C1C1C',
  embedUrl: {
    browser: `${__MAIN_URL__}/embed/QiHliSb5CrVu4l3ED6ZzQ?map=true`
  }
}]

// FIXME: Use proper embed urls
const PRODUCTION_DESTINATIONS = [{
  destination: 'Portland, OR',
  photoUrl: '/static/assets/img/backgrounds/destinations/portland.jpg',
  embedUrl: {
    browser: 'https://hipherd.com/embed/DrKslPPXRguUyvRZbwady?view=grid&map=true',
    mobile: 'https://hipherd.com/embed/DrKslPPXRguUyvRZbwady?view=list&map=true'
  }
}, {
  destination: 'Las Vegas, NV',
  photoUrl: '/static/assets/img/backgrounds/destinations/las-vegas.jpg',
  labelColor: '#595CFF',
  embedUrl: {
    browser: 'https://hipherd.com/embed/dVElcw6Q2WTri86GO_FwG?view=list&map=true'
  }
}, {
  destination: 'San Francisco, CA',
  photoUrl: '/static/assets/img/backgrounds/destinations/san-francisco.jpg',
  labelColor: '#00E3DE',
  textColor: '#1C1C1C',
  embedUrl: {
    browser: 'https://hipherd.com/embed/lE2XupCdVZ7gfqeD07hlC?map=true'
  }
}, {
  destination: 'New York, NY',
  photoUrl: '/static/assets/img/backgrounds/destinations/new-york.jpg',
  labelColor: '#FF4733',
  textColor: '#1C1C1C',
  embedUrl: {
    browser: 'https://hipherd.com/embed/98o6KNDFMT0kPxNWsCZY3??view=list&map=true'
  }
}]

export const DESTINATIONS = __PROD__ ? PRODUCTION_DESTINATIONS : STAGING_DESTINATIONS
